import { useEffect, useState } from 'react';
import { useParams, useNavigate  } from 'react-router-dom';
import {getSalesHistory, getCheckDetail} from '../../utils/api/api';
import './PurchaseHistoryPage.css'
import backIcon from '../../assets/back.png';
import CheckDetailModal from "../PurchaseHistoryPage/CheckDetailModal/CheckDetailModal";

const SalesHistoryPage = () => {
    const navigate = useNavigate();
    const { sellerId, clientId } = useParams();
    const [salesHistory, setSalesHistory] = useState([]);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [modalVisible, setModalVisible] = useState(false);
    const [checkDetails, setCheckDetails] = useState([]);
    const [, setCurrentCheckId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null); // New state for error handling

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const data = await getSalesHistory(sellerId, clientId);
                if (data && data.length > 0) {
                    setSalesHistory(data);
                } else {
                    setError('Нет данных для отображения');
                }
            } catch (fetchError) {
                void fetchError;
                setError('Что-то пошло не так, попробуйте позже');
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [sellerId, clientId]);

    const handleGoBack = () => {
        navigate(`/welcome/${sellerId}/${clientId}`);
    };

    const handleCheckClick = async (checkId) => {
        const details = await getCheckDetail(sellerId, clientId, checkId);
        setCheckDetails(details);
        setCurrentCheckId(checkId);
        setModalVisible(true);
    };

    const handleModalClose = () => {
        setModalVisible(false);
        setCheckDetails([]);
        setCurrentCheckId(null);
    };

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = salesHistory.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(salesHistory.length / recordsPerPage);

    const handleRecordsPerPageChange = (e) => {
        setRecordsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const nextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const getRowClass = (item) => {
        const returnValue = String(item.n_return);
        return returnValue === '1' ? 'return-row' : ''; // Если значение "1", то применяем класс
    };

    if (loading) {
        return <div>Загрузка...</div>;
    }

    if (error) {
        return (
            <div className="modal">
                <div className="modal-content">
                    <p>{error}</p>
                    <button onClick={handleGoBack}>Назад на главную</button>
                </div>
            </div>
        );
    }

    return (
        <div className="welcome-container">
            <div className="back-button" onClick={handleGoBack}>
                <button className="back-button-style">
                    <img
                        src={backIcon}
                        alt="Back"
                        className="back-icon"
                    />
                </button>
            </div>
            <div className="records-per-page">
                <label htmlFor="recordsPerPage">Записей на странице: </label>
                <select
                    id="recordsPerPage"
                    value={recordsPerPage}
                    onChange={handleRecordsPerPageChange}
                >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                    <option value={50}>50</option>
                </select>
            </div>
            <div className="pagination">
                <button onClick={prevPage} disabled={currentPage === 1}>
                    Предыдущая
                </button>
                <span>{`Страница ${currentPage} из ${totalPages}`}</span>
                <button onClick={nextPage} disabled={currentPage === totalPages}>
                    Следующая
                </button>
            </div>
            <div className="history-table-container">
                <table className="history-table">
                    <thead>
                    <tr>
                        <th>Торговая точка</th>
                        <th>Дата операции</th>
                        <th>Начислено бонусов</th>
                        <th>Списано бонусов</th>
                        <th>Номер Чек</th>
                        <th>Цена</th>
                        <th>Цена до скидки</th>
                        <th>Оценка</th>
                        <th>Возврат чека</th>
                    </tr>
                    </thead>
                    <tbody>
                    {currentRecords.map((item, index) => {
                        const rowClass = getRowClass(item);

                        return (
                            <tr key={index} className={rowClass}>
                                <td>{item.s_point}</td>
                                <td>{item.d_date}</td>
                                <td style={{ color: item.bonus_add === '.00' ? 'green' : 'green' }}>
                                    {item.bonus_add === '.00' ? '0' : item.bonus_add}
                                </td>
                                <td style={{ color: item.bonus_sub === '.00' ? 'red' : 'red' }}>
                                    {item.bonus_sub === '.00' ? '0' : item.bonus_sub}
                                </td>
                                <td>
                                    <button
                                        onClick={() => handleCheckClick(item.s_check)}
                                        className="check-button"
                                    >
                                        <span className="check-button-text">{item.s_check}</span>
                                        <i className="check-button-icon">&#128462;</i>
                                    </button>
                                </td>
                                <td>{item.n_amount}</td>
                                <td>{item.n_amount_full}</td>
                                <td>
                                    <div className="stars">
                                        {[1, 2, 3, 4, 5].map((star) => (
                                            <span
                                                key={star}
                                                className={`star
                                                    ${star <= (item.n_rating || 0) ? 'filled' : ''}
                                                    ${item.n_return === '1' ? 'disabled' : ''}`}
                                            >
                                                ★
                                            </span>
                                        ))}
                                    </div>
                                </td>
                                <td>{item.n_return === '1' ? 'Да' : 'Нет'}</td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
                <CheckDetailModal
                    isVisible={modalVisible}
                    checkDetails={checkDetails}
                    onClose={handleModalClose}
                />
            </div>
        </div>
    );
};


export default SalesHistoryPage;



